import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

import { CONTINUE_BUTTON_CLASS } from "components/FormV2";
import { CallButton, ReentryFrame } from "pages/QuoteFlow/ReentryParts";
import type { ConfirmRefusal } from "pages/StartLead/submissionStatus";

import {
  START_AGAIN_LABEL,
  USE_DIFFERENT_LABEL,
  refusedCopyFor,
} from "./verify";

/**
 * What a visitor is told when the submission cannot be confirmed for them:
 * start a new request when it expired or closed, or sign out and look up
 * with another email or phone when it is not theirs to open.
 */
export default function Refused({
  reason,
  line,
  onUseDifferent,
}: {
  reason: ConfirmRefusal;
  line: { href: string; label: string };
  onUseDifferent: () => void;
}) {
  const copy = refusedCopyFor(reason);
  return (
    <ReentryFrame>
      <div className="flex h-12 w-12 flex-none items-center justify-center rounded-full bg-oat">
        <ExclamationCircleIcon
          className="h-5 w-5 text-evergreen"
          strokeWidth={2}
          aria-hidden="true"
        />
      </div>
      <h1 className="font-serif text-[25px] leading-tight text-soil sm:text-[31px]">
        {copy.title}
      </h1>
      <div className="flex w-full flex-col items-center gap-3">
        {copy.action === "start_again" ? (
          <Link to="/start" className={CONTINUE_BUTTON_CLASS}>
            {START_AGAIN_LABEL}
          </Link>
        ) : (
          <button
            type="button"
            className={CONTINUE_BUTTON_CLASS}
            onClick={onUseDifferent}
          >
            {USE_DIFFERENT_LABEL}
          </button>
        )}
        <CallButton
          line={line}
          track={{ surface: "verify", screen: "refused" }}
        />
      </div>
    </ReentryFrame>
  );
}
